// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3KVly","description":"PatientConsentPreview_description__3Bs8J"};